<template>
  <section>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-card-body>
            <b-card-text>
              <b-row>
                <b-col lg="6" cols="12">
                  <template>
                    <h5 class="text-capitalize">Current Package</h5>

                    <div v-if="companyData?.package">
                      <b-card-text> <strong>Title:</strong> {{ companyData?.package?.title }}</b-card-text>
                      <b-card-text> <strong>Billing Cycle:</strong>
                        <template v-if="companyData?.package?.billing_cycle === 'monthly'">
                          Monthly
                        </template>
                        <template v-else-if="companyData?.package?.billing_cycle === 'yearly'">
                          Yearly
                        </template>
                        <template v-else>
                          Life Time
                        </template>
                      </b-card-text>
                      <b-card-text> <strong>Max User:</strong> {{ companyData?.package?.max_user }} users</b-card-text>

                    </div>
                  </template>
                </b-col>
                <b-col lg="6" cols="12">

                  <b-card-text> <strong>Subscription Expire Date:</strong> {{ subscriptionExpireDate ? formatSubscriptionExpiredDateTime(subscriptionExpireDate) : 'N/A'  }}</b-card-text>

                      <b-button
                        v-ripple.400="'rgba(255, 159, 67, 0.15)'"
                        variant="flat-warning"
                        class="border"
                        @click="showModal = true"
                      >
                      Cancel Subscription
                      </b-button>
                      <router-link to="/pricing">
                        <b-button
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-success"
                          class="border mx-1"
                        >
                          Update Package
                        </b-button>
                      </router-link>

                  <!-- <template>
                    <h5 class="text-capitalize">Days</h5>

                    <div>
                      <label
                        >{{ value }} days remaining of your next payment</label
                      >
                      <b-progress :max="max">
                        <b-progress-bar :value="value">
                          <strong>{{ value }} / {{ max }}</strong>
                        </b-progress-bar>
                      </b-progress>
                    </div>
                  </template> -->
                </b-col>
              </b-row>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-card>
      <div>
        <!-- table -->
        <vue-good-table
          styleClass="vgt-table table-custom-style striped"
          :line-numbers="false"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          :rows="rows"
          :columns="columns"
          :sort-options="{
            enabled: false,
            multipleColumns: true,
            initialSortBy: [{ field: 'created_at', type: 'desc' }],
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <!-- payment date -->
            <template v-if="props?.column?.field === 'format_created_at'">
              <div v-if="props.row.created_at">
                {{ formatDateTime(props.row.created_at) }}
              </div>
            </template>

            <template v-if="props?.column?.field === 'format_updated_at'">
              <div v-if="props.row.updated_at">
                {{ formatDateTime(props.row.updated_at) }}
              </div>
            </template>

            <template v-if="props?.column?.field === 'format_amount'">
              <div v-if="props.row.amount_paid">
                <div>
                  {{ props?.row?.currency?.toUpperCase() }}
                  {{ props.row.amount_paid }}
                </div>
              </div>
            </template>

            <!-- next payment date -->
            <template
              v-if="props?.column?.field === 'format_next_payment_date'"
            >
              <div v-if="props.row.next_payment_date">
                {{ formatDateTime(props.row.next_payment_date) }}
              </div>
            </template>

            <template v-if="props?.column?.field === 'format_status'">
              <b-badge :variant="getStatusVariant(props.row.status)">
                {{ getStatusText(props.row.status) }}
            </b-badge>
            </template>

            <template v-if="props?.column?.field === 'format_payment_status'">
              <b-badge :variant="getPaymentStatusVariant(props.row.payment_status)">
                {{ props.row.payment_status }}
              </b-badge>
              <b-button
                v-if="props.row.payment_status === 'UnPaid'"
                size="sm"
                variant="primary"
                class="mx-1"
                @click="goToPayment(props.row)"
              >
                Invoice
              </b-button>
              <b-button
                v-if="props.row.payment_status === 'Paid'"
                size="sm"
                variant="primary"
                class="mx-1"
                @click="downloadInvoice(props.row)"
              >
                Download Invoice
              </b-button>
            </template>
          </template>

          <!-- pagination -->
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap"> Showing 1 to </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['10', '25', '50', '100', '500']"
                  class="mx-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap"> of {{ props.total }} entries </span>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => props.pageChanged({ currentPage: value })"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
    </b-card>

    <b-modal v-model="showModal" title="Cancel Subscription" hide-footer>
      <p class="my-2">Do you want to cancel now or at the end of your package?</p>

      <div class="d-flex justify-content-between">
        <!-- Cancel Now Button with Tooltip -->
        <b-button
          variant="danger"
          @click="pauseSubscription"
          v-b-tooltip.hover
          title="If you cancel now, your subscription will end immediately. You won't be able to use the service after 24 hours."
        >
          Cancel Now
        </b-button>

        <!-- Cancel at End of Package Button with Tooltip -->
        <b-button
          variant="warning"
          @click="cancelAtEndSubscription"
          v-b-tooltip.hover
          title="If you cancel at the end of the package, you can continue using your subscription until it expires. After that, access will be revoked."
        >
          Cancel at End of Package
        </b-button>
      </div>


      <b-button class="mt-3" variant="secondary" block @click="showModal = false">
        Close
      </b-button>
    </b-modal>

    <b-sidebar
      id="payment-sidebar"
      title="Complete Payment"
      shadow
      right
      :visible="showPaymentSidebar"
      @hidden="showPaymentSidebar = false"
    >
      <div class="p-3">
        <div class="border rounded bg-white p-3 shadow-sm">

          <!-- Invoice Header -->
          <div class="text-center mb-4">
            <h4 class="font-weight-bold">INVOICE</h4>
            <small class="text-muted">
              Transaction ID:
              <strong>{{ selectedPayment?.transaction_id || 'N/A' }}</strong>
            </small>
          </div>

          <!-- Billed To -->
          <div class="mb-2">
            <h6 class="text-primary">Billed To:</h6>
            <p class="mb-1">Company Name: <strong>{{ companyInformation?.name }}</strong></p>
            <p class="mb-1">E-mail: {{ companyInformation?.email }}</p>
            <p>Contact No: {{ companyInformation?.contact_no || 'N/A' }}</p>
            <p>Address: {{ companyInformation?.address || 'N/A' }}</p>
          </div>
          
          <div class="mb-2" style="max-width: 400px;">
                <p><strong>Have a Coupon?</strong></p>
                <div class="d-flex">
                  <b-form-input
                    id="coupon-code"
                    v-model="couponCode"
                    placeholder="Enter coupon code"
                    :disabled="selectedPayment?.payment_status === 'Paid'"
                    class=""
                  >
                </b-form-input>
                  <b-input-group-append>
                    <b-button
                      variant="success"
                      @click="applyCoupon"
                      class="mx-1"
                      :disabled="!couponCode || loadingCoupon || selectedPayment?.payment_status === 'Paid'"
                    >
                      {{ loadingCoupon ? 'Applying...' : 'Apply' }}
                    </b-button>
                  </b-input-group-append>
                </div>
                
              <small v-if="couponError" class="text-danger">{{ couponError }}</small>
              <small v-if="couponSuccess" class="text-success">{{ couponSuccess }}</small>
          </div>

          <!-- Package Table -->
          <table class="table table-sm mb-4">
            <thead class="thead-light">
              <tr>
                <th>Package</th>
                <th class="text-right">Price (USD)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ companyInformation?.package?.title }}
                  <br>
                  <small class="text-muted">Billing Cycle: {{ companyInformation?.package?.billing_cycle }}</small> <br>
                  <small class="text-muted">Max Users: {{ companyInformation?.package?.max_user }}</small>
                </td>
                <td class="text-right">{{ getFinalPrice() }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>Total</th>
                <th class="text-right">{{ getTotalPrice() }} {{ selectedPayment?.currency }}</th>
              </tr>
            </tfoot>
          </table>

          <!-- Status -->
          <div class="mb-3">
            <p class="mb-1">
              <strong>Status: </strong>
              <b-badge :variant="selectedPayment?.payment_status === 'Paid' ? 'success' : 'danger'">
                {{ selectedPayment?.payment_status }}
              </b-badge>
            </p>
            <p class="mb-1">
              <strong>Next Payment Date:</strong> {{ formatDateTime(selectedPayment?.next_payment_date) }}
            </p>
          </div>

          <hr>

          <!-- Confirmation Checkbox -->
          <b-form-checkbox
            v-model="confirmChecked"
            class="mb-2"
            :disabled="selectedPayment?.payment_status === 'Paid'"
          >
            I agree with
            <a href="https://hrms.taskfino.com/terms-and-condition" target="_blank">Terms and Conditions</a>,
            <a href="https://hrms.taskfino.com/return-and-refund" target="_blank">Return and Refund Policy</a>, and
            <a href="https://hrms.taskfino.com/privacy-policy" target="_blank">Privacy Policy</a>.
          </b-form-checkbox>

          <!-- Warning Message -->
          <div class="mb-2">
            <b-alert
              v-if="confirmChecked"
              variant="warning"
              show
            >
              ⚠️ Please ensure your information is accurate before proceeding. Payments are non-refundable once confirmed.
            </b-alert>
          </div>

          <!-- Confirm Button -->
          <b-button
            block
            variant="primary"
            size="lg"
            :disabled="!confirmChecked || selectedPayment?.payment_status === 'Paid'"
            @click="confirmPayment"
          >
            {{ selectedPayment?.payment_status === 'Paid' ? 'Already Paid' : 'Pay Now' }}
          </b-button>

        </div>
      </div>
    </b-sidebar>


  <b-modal
    id="payment-success-modal"
    title="Payment Successful"
    centered
    ok-only
    @ok="goToPaymentHistories"
    ok-variant="success"
  >
    <div class="text-center py-3">
      <b-icon icon="check-circle-fill" variant="success" font-scale="3"></b-icon>
      <p class="mt-3 mb-0">Your payment was completed successfully.</p>
    </div>
  </b-modal>

  <b-modal
    id="payment-fail-modal"
    title="Payment Failed"
    centered
    ok-only
    @ok="goToPaymentHistories"
    ok-variant="danger"
  >
    <div class="text-center py-3">
      <b-icon icon="x-circle-fill" variant="danger" font-scale="3"></b-icon>
      <p class="mt-3 mb-0">Your payment could not be processed. Please try again.</p>
    </div>
  </b-modal>



  </section>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BRow,
  BCol,
  VBTooltip,
  BProgress,
  BProgressBar,
  BCardBody,
  BCardText,
  BSidebar,
  BFormCheckbox,
  BAlert,
  BInputGroup,
  BInputGroupAppend
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, max } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import UserAssignPolicyForm from "@/views/admin/payroll-management/UserAssignPolicyForm.vue";

export default {
  name: "PaymentHistory",
  components: {
    UserAssignPolicyForm,
    BForm,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BRow,
    BCol,
    VBTooltip,
    BProgress,
    BProgressBar,
    BCardBody,
    BCardText,
    BSidebar,
    BFormCheckbox,
    BAlert,
    BInputGroup,
    BInputGroupAppend
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {

      modelType: "",
      name: "",
      showModal: false,
      companyId: "",

      value: 0,
      max: 0,
      companyData: "",
      subscriptionExpireDate: "",

      pageLength: 10,
      columns: [
        {
          label: "Invoice Create Date",
          field: "format_created_at",
          sortable: false,
        },
        {
          label: "Payment Date",
          field: "format_updated_at",
          sortable: false,
        },
        {
          label: "Amount",
          field: "format_amount",
          sortable: false,
        },
        {
          label: "Status",
          field: "format_status",
          sortable: false,
        },
        {
          label: "Payment Status",
          field: "format_payment_status",
          sortable: false,
        },
        {
          label: "Next Payment Date",
          field: "format_next_payment_date",
          sortable: false,
        },
      ],
      rows: [],
      searchTerm: "",
      delayTimer: null,
      isLoading: false,
      isSalaryPolicyFormSubmitLoading: false,
      isUserPolicyAssignFormSubmitLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          { field: "id", type: "desc" },
          { field: "created_at", type: "desc" },
        ],
        page: 1,
        perPage: 10,
      },
      showPaymentSidebar: false,
      companyInformation: null,
      selectedPayment: null,
      confirmChecked: false,
      couponCode: "",
      couponError: "",
      couponSuccess: "",
      loadingCoupon: false,
      discountedPrice: null,
      discountAmount: null,
    };
  },

  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
      authUser: "userModule/getUser",
    }),
    statusVariant() {
      const statusColor = {
        true: "light-success",
        false: "light-danger",
      };

      return (status) => statusColor[status];
    },
    getPaymentMethod() {
      return this.$store.getters["paymentMethodModule/getPaymentMethod"];
    },
  },

  async created() {
    this.companyId = this.authUser?.company_id ?? "";
    try {
      const response = await this.getCompanyInfo(this.companyId);
      this.companyData = response?.data?.data;

      this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }

    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get("status");

    if (status === "success") {
      this.$bvModal.show("payment-success-modal");
    } else if (status === "fail" || status === "cancel") {
      this.$bvModal.show("payment-fail-modal");
    }
  },

  methods: {
    async applyCoupon() {
      if (!this.couponCode) return;

      this.couponError = "";
      this.couponSuccess = "";
      this.loadingCoupon = true;

      try {
        const response = await this.$api.get(`/api/coupon/verify`, {
          params: { code: this.couponCode, package_id: this.companyInformation?.package?.id }
        });

        if (response.data.status === "success") {
          this.discountedPrice = response?.data?.discounted_price; // API should return new price
          this.discountAmount = response?.data?.discount_amount
          this.couponSuccess = `Coupon applied! You saved ${response?.data?.discount_amount} ${this.selectedPayment?.currency}`;
        } else {
          this.couponError = response.data.message || "Invalid coupon code";
        }
      } catch (error) {
        this.couponError = error.response?.data?.message || "Error verifying coupon";
      } finally {
        this.loadingCoupon = false;
      }
    },
    getFinalPrice() {
      return this.discountedPrice?.toFixed(2) ?? this.companyInformation?.package?.price;
    },
    getTotalPrice() {
      const discount = parseFloat(this.discountAmount || 0); // ensure it's a number
      const amountPaid = parseFloat(this.selectedPayment?.amount_paid || 0);

      const price = amountPaid - discount;

      // if price is NaN or invalid, fallback to original amount
      if (isNaN(price)) {
        return amountPaid.toFixed(2);
      }

      return price.toFixed(2);
    },

    async downloadInvoice(payment) {
      const response = await this.getCompanyInformation(this.companyId);
      this.companyInformation = response?.data;

      const invoiceHtml = `
        <html>
          <head>
            <title>Invoice - ${payment.transaction_id}</title>
            <style>
              body { font-family: Arial, sans-serif; padding: 40px; }
              h2 { text-align: center; margin-bottom: 30px; }
              table { width: 100%; border-collapse: collapse; margin-top: 20px; }
              th, td { border: 1px solid #ccc; padding: 10px; text-align: left; }
              .total { text-align: right; font-weight: bold; }
            </style>
          </head>
          <body>
            <h2>INVOICE</h2>
            <p><strong>Transaction ID:</strong> ${payment.transaction_id || 'N/A'}</p>
            <p><strong>Company:</strong> ${this.companyInformation.name}</p>
            <p><strong>Email:</strong> ${this.companyInformation.email}</p>
            <p><strong>Contact:</strong> ${this.companyInformation.contact_no || 'N/A'}</p>
            <p><strong>Address:</strong> ${this.companyInformation.address || 'N/A'}</p>

            <table>
              <thead>
                <tr>
                  <th>Package</th>
                  <th>Billing Cycle</th>
                  <th>Max Users</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>${this.companyInformation.package.title}</td>
                  <td>${this.companyInformation.package.billing_cycle}</td>
                  <td>${this.companyInformation.package.max_user}</td>
                  <td>${this.companyInformation.package.price} USD</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" class="total">Total:</td>
                  <td><strong>${payment.amount_paid} ${payment.currency}</strong></td>
                </tr>
              </tfoot>
            </table>

            <p><strong>Status:</strong> ${payment.payment_status}</p>
            <p><strong>Next Payment Date:</strong> ${this.formatDateTime(payment.next_payment_date)}</p>

            <script>
              window.onload = function () {
                window.print();
                window.onafterprint = () => window.close();
              };
            <\/script>
          </body>
        </html>
      `;

      // Open a new window and write the invoice HTML into it
      const printWindow = window.open('', '_blank');
      printWindow.document.open();
      printWindow.document.write(invoiceHtml);
      printWindow.document.close();
    },
    goToPaymentHistories() {
      this.$router.push('/payment-histories');
    },
    async confirmPayment(){
      const domain = window.location.origin;
      const response = await this.initiateShurjoPayment(
        {
          email: this.companyInformation.email,
          company_name: this.companyInformation.name,
          package_id: this.companyInformation.package.id,
          contact_no: this.companyInformation.contact_no,
          redirectSuccessUrl: `${domain}/payment-histories?status=success`,
          redirectFailUrl: `${domain}/payment-histories?status=fail`,
          redirectCancelUrl: `${domain}/payment-histories?status=cancel`,
          payment_history_id: this.selectedPayment.id,
          coupon_code: this.couponCode ?? null,
        }
      )
      if (response?.data) {
        window.location.href = response?.data?.data; // Redirect to payment gateway
      }
    },
    async goToPayment(row) {
      const response = await this.getCompanyInformation(this.companyId);
      this.companyInformation = response?.data;
      this.selectedPayment = row;
      this.showPaymentSidebar = true
    },
    completePayment() {
      this.showPaymentSidebar = false
    },
    daysInProgressBar(data) {
      if (data) {
          const createdAt = new Date(data.created_at);
          const nextPaymentDate = new Date(data.next_payment_date);
          const today = new Date();

          const maxDuration = Math.floor((nextPaymentDate - createdAt) / (1000 * 60 * 60 * 24));

          const elapsedDuration = Math.floor((today - createdAt) / (1000 * 60 * 60 * 24));

          this.max = maxDuration;
          this.value = elapsedDuration;
        }
    },
    capitalizeFirstLetter(string) {
      if (!string) return "";
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    formatDateTime(value) {
      if (value) {
        return this.$moment(value).format("MMM Do YYYY");
      }
    },

    formatSubscriptionExpiredDateTime(value) {
      if (value) {
        return this.$moment(value).subtract(1, 'days').format("MMM Do YYYY");
      }
    },

    onSearch() {
      if (this.delayTimer) {
        clearTimeout(this.delayTimer);
        this.delayTimer = null;
      }

      this.delayTimer = setTimeout(() => {
        this.loadItems();
      }, 1000);
    },

    async getPaymentHistory(params) {
      return await this.$api.get("api/subscription-history", {
        params: {
          company_id: params.company_id,
          show: params.show,
          page: params.page,
          sort: params.sort,
          q: params.q,
          payment_method: params.payment_method,
        },
      });
    },

    async getCompanyInfo(companyId) {
      return await this.$api.get("api/current-subscription-package", {
        params: {
          company_id: companyId,
        },
      });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },

    async loadItems() {
      try {
        const paymentHistories = await this.getPaymentHistory({
          company_id: this.companyId,
          show: this.serverParams.perPage,
          page: this.serverParams.page,
          sort: this.serverParams.sort,
          q: this.searchTerm,
          payment_method: this.getPaymentMethod,
        });

        const data = paymentHistories?.data?.data;
        const meta = paymentHistories?.data?.meta;
        this.subscriptionExpireDate = meta?.companyData?.subscription_expire_date;

        this.totalRecords = meta?.pagination?.total;
        this.rows = data;

        if (this.rows.length > 0) {
          this.daysInProgressBar(this.rows[0]);
        }
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },

    async getPauseSubscription(params) {
      return await this.$api.post("api/shurjopay/pause-resume-cancel-subscription", {
        params: {
          company_id: params.company_id,
          subscription_status: params.subscription_status,
        },
      });
    },

    async initiateShurjoPayment(params) {
      return await this.$api.post("api/shurjopay/recurring-payment", {
          email: params.email,
          company_name: params.company_name,
          package_id: params.package_id,
          contact_no: params.contact_no,
          redirectSuccessUrl: params.redirectSuccessUrl,
          redirectFailUrl: params.redirectFailUrl,
          redirectCancelUrl: params.redirectCancelUrl,
          payment_history_id: params.payment_history_id,
          coupon_code: params.coupon_code,
      });
    },

    async getCompanyInformation(companyId) {
      return await this.$api.get("api/shurjopay/company-information", {
        params: {
          company_id: companyId,
        },
      });
    },

    async pauseSubscription() {
      this.$swal({
        title: "Warning!",
        html: `This action is irreversible! <br> Are you sure, You want to cancel your subscription?`,
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Delete",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await this.getPauseSubscription({
                  company_id: this.authUser?.company_id,
                  subscription_status: 3
                });

              if (response.data.status == "success") {
                this.showModal = false
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Success",
                  icon: "BellIcon",
                  variant: "success",
                  text: response.data.message,
                },
              });

            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              });
            }
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },

    async postCancelAtEndSubscription(params) {
      return await this.$api.post("api/cancel-end-of-expire-subscription", {
        params: {
          company_id: params.company_id,
          subscription_status: params.subscription_status,
        },
      });
    },

    async cancelAtEndSubscription() {
      this.$swal({
        title: "Warning!",
        html: `This action is irreversible! <br> Are you sure, You want to cancel your subscription?`,
        icon: "warning",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Delete",
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await this.postCancelAtEndSubscription({
                  company_id: this.authUser?.company_id,
                  subscription_status: 3
                });

              if (response.data.status == "success") {
                this.showModal = false
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Success",
                    icon: "BellIcon",
                    variant: "success",
                    text: response.data.message,
                  },
                });

            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: response.data.message,
                },
              });
            }
          } catch (error) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                icon: "BellIcon",
                variant: "danger",
                text: error?.response?.data?.message,
              },
            });
          }
        }
      });
    },

    getStatusVariant(status) {
        switch(status) {
          case 'complete':
            return 'light-success'; // Green for completion
          case 'on_payment':
              return 'light-success'; // Green for payment in progress
          case 'pause':
              return 'light-danger'; // Red for paused state
          case 'resume':
              return 'light-primary'; // Blue for resumed state
          case 'cancel':
              return 'light-danger'; // Red for cancellation
          case 'trial':
              return 'light-warning';;
            default:
                return 'light-secondary'; // default color
        }
    },
    getStatusText(status) {
        switch(status) {
            case 'complete':
                return 'Complete';
            case 'on_payment':
                return 'On Payment';
            case 'resume':
                return 'Resume';
            case 'cancel':
                return 'Inactive';
            case 'pause':
                return 'Paused';
            case 'trial':
                return 'Trial';
            default:
                return 'Unknown';
        }
    },

    getPaymentStatusVariant(status) {
        switch(status) {
          case 'UnPaid':
            return 'light-danger'; // Green for completion
          case 'Paid':
              return 'light-success'; // Green for payment in progress
            default:
                return 'light-secondary'; // default color
        }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.required-label label::after {
  content: " *";
  color: red;
}
.b-sidebar {
  width: 70% !important;
}
</style>
